import { Injectable } from '@angular/core';
import { CommunicationService } from '../../../../../services/communication/communication.service';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ProductionByOperatorService {
  constructor(public communicationService: CommunicationService, private urlBuilderService: UrlBuilderService) {}

  /**
   * get all filter orderBy
   * @param machineType machine type to get filters labels
   */
  public getFilter(machineTypeId: number): Promise<any> {
    const url = `${this.urlBuilderService.serverBasePath}/Production/GetOrderProductionOperator`;
    const params = { machineTypeId };
    return this.communicationService.get(url, params).toPromise();
  }

  /**
   * get information fill modal production by operator
   * @params params
   */
  public getInformationModal(params: any): Promise<any> {
    const url = `${this.urlBuilderService.serverBasePath}/Production/GetProductionDetailByOperator`;
    return this.communicationService.get(url, params).toPromise();
  }

  /**
   * get production by operator
   * @params params
   */
  public getProductionByOperator(params: any): Promise<any> {
    const url = `${this.urlBuilderService.serverBasePath}/Production/ProductionByOperator`;
    return this.communicationService.get(url, params).toPromise();
  }
}
